import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useNivelCriticidade = () => {
  const [nivelCriticidade, setNivelCriticidade] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchNivelCriticidade = async () => {
      try {
        const response = await httpClient.get(`/api/destaque/nivelcriticidade`);

        const options = response.data.map(
          (nivelCriticidade: { value: number; label: string }) => ({
            value: nivelCriticidade.value.toString(),
            label: nivelCriticidade.label,
          }),
        );
        setNivelCriticidade(options);
      } catch (error) {
        console.error('Erro ao buscar Nível de Criticidade', error);
      }
    };

    fetchNivelCriticidade();
  }, []);

  return nivelCriticidade || [];
};
